<template>
  <div>
    <p class="text-sm mb-4">Détail des coûts de la facture</p>
    <Table :columns="columns" :data="invoice.costs">
      <template #type="{ row }">
        <p>{{ $t(`claim.cost_type.${row.type}`) }}</p>
      </template>
    </Table>
  </div>
</template>

<script>
import { Table } from "@estaly/ui";

export default {
  components: { Table },
  props: ["invoice"],

  computed: {
    columns() {
      return [
        {
          label: "Type",
          field: "type",
          slot: "type",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "Prix unitaire HT",
          field: "unitPriceBeforeTax",
          price: true,
        },
        {
          label: "Prix unitaire TTC",
          field: "unitPrice",
          price: true,
        },
        {
          label: "Quantité",
          field: "quantity",
          numeric: true,
        },
        {
          label: "Total",
          field: "total",
          price: true,
          bold: true,
        },
      ];
    },
  },
};
</script>
